import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { Button } from "@upstageai/ui";

import { cn } from "../../utils/style";

export default function ConfigOpenButton({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) {
  return (
    <Button
      size="icon"
      variant="outline"
      onClick={onClick}
      className={cn(className)}
    >
      <AdjustmentsHorizontalIcon className="size-4" />
    </Button>
  );
}
